export const data3_2_1 = [{
    name: "酒店名称",
    end_budget_nts: 0,
    end_budget_adr: 1,
    end_budget_rev: 2,
    end_budget_occ: 3,
    end_actual_nts: 4,
    end_actual_adr: 5,
    end_actual_rev: 6,
    end_actual_occ: 7,
    end_varies_nts: 8,
    end_varies_adr: 9,
    end_varies_rev: 10,
    end_varies_occ: 11,
    ytd_budget_nts: 12,
    ytd_budget_adr: 13,
    ytd_budget_rev: 14,
    ytd_budget_occ: 15,
    ytd_actual_nts: 16,
    ytd_actual_adr: 17,
    ytd_actual_rev: 18,
    ytd_actual_occ: 19,
    ytd_varies_nts: 20,
    ytd_varies_adr: 21,
    ytd_varies_rev: 22,
    ytd_varies_occ: 23,
}];



// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/4_2Month/data.js